// src/components/Admin/InstitutionCmp/InstitutionProfile/InstitutionPlan.js
import React from "react";
import { Table, Image } from "semantic-ui-react";
import { useTranslation } from "react-i18next";

export function InstitutionPlan({ data }) {
  const { planEduca, expired_at } = data;
  const { t } = useTranslation("institutions");

  if (!planEduca) {
    return <p>{t("profile.noPlan")}</p>;
  }
  const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString() : "–");
  const {
    title,
    miniature,
    account,
    //price,
    accessTime,
    vrHeadsetNumber,
    vrHeadsetModel,
    bagModel,
    curseBasic,
    curseCertification,
    publicity,
  } = planEduca;

  return (
    <Table definition compact>
      <Table.Body>
        <Table.Row>
          <Table.Cell>
            <Image src={miniature} size="mini" />
          </Table.Cell>
          <Table.Cell>{title}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{t("profile.licenseLabel")}</Table.Cell>
          <Table.Cell>{account}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{t("profile.expiresLabel")}</Table.Cell>
          <Table.Cell>{fmt(expired_at)}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{t("profile.durationLabel")}</Table.Cell>
          <Table.Cell>
            {accessTime} {t("profile.durationUnit")}
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{t("profile.vrLabel")}</Table.Cell>
          <Table.Cell>
            {vrHeadsetNumber} × {vrHeadsetModel || "–"}
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{t("profile.bagLabel")}</Table.Cell>
          <Table.Cell>{bagModel || "–"}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{t("profile.basicCourseLabel")}</Table.Cell>
          <Table.Cell>
            {curseBasic ? t("profile.yes") : t("profile.no")}
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{t("profile.certificationLabel")}</Table.Cell>
          <Table.Cell>
            {curseCertification ? t("profile.yes") : t("profile.no")}
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{t("profile.advertisingLabel")}</Table.Cell>
          <Table.Cell>
            {publicity ? t("profile.yes") : t("profile.no")}
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
}
